import React, { useState, useEffect } from "react";
import { Hero } from "../../components/header/header";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import RegisterInterestStep1 from "./RegisterInterestStep1.js";
import RegisterInterestStep2 from "./RegisterInterestStep2.js";

import './conference.css';

function ConferenceRegisterInterest() {
  const pageTitle = "UK Tanners Conference 2026";
  document.title = global.AppName + " - " + pageTitle;
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Step 1: Registration form state
  const [step, setStep] = useState(1);
  const [registerData, setRegisterData] = useState({
    firstname: "",
    surname: "",
    email: "",
    id: "",
    captcha: "",
    subscribeConference: false,
    subscribe: false,
  });
  const [isRegisterDisabled, setIsRegisterDisabled ] = useState(true);
  
  // Step 2: Survey form state
  const [surveyData, setSurveyData] = useState({
    accommodation: "",
    other: {
      accommodation: "",
      interest: "",
      leather: "",
    },
    dates: [],
    leather: [],
    interest: "",
  });
  const [isSurveyDisabled, setIsSurveyDisabled ] = useState(false);
  
  // Step 3: Thank you message state
  const [wizardResponse, setWizardResponse] = useState({
    message: "",
    success: false,
  });

  const { executeRecaptcha } = useGoogleReCaptcha();
  
  const handleRegisterChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox")
      setRegisterData({ ...registerData, [e.target.name]: e.target.checked });
    else
      setRegisterData({ ...registerData, [e.target.name]: e.target.value });
    };
   
  useEffect(() => {
    setIsRegisterDisabled(!registerData.firstname || !registerData.surname || !registerData.emailFrom || !registerData.subscribeConference);
  }, [registerData]);

  async function handleRegisterSubmit(e) {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const token = await executeRecaptcha("conference_register_interest");
      var formSubmitData = { ...registerData, captcha: token, WebsiteId: "cotmarshtannery" };
 
      //  const response = fetch('https://creweallen-function.azurewebsites.net/api/ConferenceRegisterInterest', { 
      //  const response = fetch('http://localhost:7071/api/ConferenceRegisterInterest', { 
     const response = await fetch(process.env.REACT_APP_API_ENDPOINT + '/ConferenceRegisterInterest', {
        method: "POST",
        body: JSON.stringify(formSubmitData),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      });
      const result = await response.json();

      if (result.status === 'success') {
        setRegisterData({ ...registerData, "id": result.message });
        setStep(2);
      } else {
        setWizardResponse({ ...wizardResponse, "message": "There was an error submitting your registration. Please try again later." });
        setStep(3);
      }
    } catch (error) {
      setWizardResponse({ ...wizardResponse, "message": "There was an error submitting your registration. Please try again later." });
      setStep(3);
    }
    setIsSubmitting(false);
  }

  const handleSurveyChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "dates") {
      setSurveyData((prev) => ({
        ...prev,
        dates: checked
          ? [...prev.dates, value]
          : prev.dates.filter((d) => d !== value),
      }));
    } else if (name === "leather") {
      setSurveyData((prev) => ({
        ...prev,
        leather: checked
          ? [...prev.leather, value]
          : prev.leather.filter((d) => d !== value),
      }));
    } else if (name === "otherAccommodation" || name === "otherInterest" || name === "otherLeather") {
      const key = name.replace(/^other/, "");
      const formattedKey = key.charAt(0).toLowerCase() + key.slice(1);
      setSurveyData((prev) => ({
        ...prev,
        other: {
          ...prev.other,
          [formattedKey]: value,
        },
      }));
    } else {
      setSurveyData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } 
  };

  useEffect(() => {
    setIsSurveyDisabled(
      (surveyData.accommodation === "Other" && !surveyData.other.accommodation.length) ||
      (surveyData.interest === "Other" && !surveyData.other.interest.length) ||
      (surveyData.leather.includes("Other") && !surveyData.other.leather.length)
    );
  }, [surveyData]);

  async function  handleSurveySubmit(e) {
    e.preventDefault();
    setIsSubmitting(true);

    try {
        const token = await executeRecaptcha("conference_register_survey");
        var formSubmitData = { ...surveyData, captcha: token, WebsiteId: "cotmarshtannery", Id: registerData.id};
        
        //  const response = await fetch('https://creweallen-function.azurewebsites.net/api/ConferenceRegisterSurvey', { 
        //  const response = await fetch('http://localhost:7071/api/ConferenceRegisterSurvey', { 
        const response = await fetch(process.env.REACT_APP_API_ENDPOINT + '/ConferenceRegisterSurvey', {
          method: "POST",
          body: JSON.stringify(formSubmitData),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        });
        const result = await response.json();
        if (result.status === 'success') {
          setWizardResponse({ ...wizardResponse, "message": "Thank you for completing the survey! We will use your responses to help plan the conference." });
          wizardResponse.success = true;
        } else {
          setWizardResponse({ ...wizardResponse, "message": "There was an error submitting your survey. Thank you for trying anyway" });
        }
      } catch (error) {
        setWizardResponse({ ...wizardResponse, "message": "There was an error submitting your survey. Thank you for trying anyway" });
      }

      setStep(3);
      setIsSubmitting(false);
    }

  return (
    <>
      <Hero title={"UK Micro Tanners"} subtitle={"Conference 2026"}></Hero>

      {/* start main */}
      <div className="main_bg">
        <div className="wrap">
          <div className="main" id="home">
            <h2>The Conference</h2>

            {step === 1 && (
              <RegisterInterestStep1
                registerData={registerData}
                onChange={handleRegisterChange}
                onSubmit={handleRegisterSubmit}
                disabled={isRegisterDisabled || isSubmitting}
              />
            )}
            {step === 2 && (
              <RegisterInterestStep2
                surveyData={surveyData}
                onChange={handleSurveyChange}
                onSubmit={handleSurveySubmit}
                disabled={isSurveyDisabled || isSubmitting}
              />
            )}
            {step === 3 && (
              <div style={{ textAlign: "center" }}>
                {wizardResponse.status && (<h3>Thank you for registering your interest!</h3>)}
                <p>{wizardResponse.message}</p>
              </div>
            )}
            <div className="clear"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default () => (
    <GoogleReCaptchaProvider reCaptchaKey="6LeU2n4pAAAAACRrmBrl6o6WbHSw-jRCtVZBiCd2" size="compact" badge="bottomright">
      <ConferenceRegisterInterest />
    </GoogleReCaptchaProvider>
  );